import apis from './apis';

export const getCollectionStatus = (collectionReference, collectionPostcode) =>
  apis.get('collections/find', {
    params: {
      collectionReference,
      collectionPostcode,
    },
  });
